import React, { useEffect } from 'react'
import { WizardHeader } from './WizardHeader'
import { CompactFooter } from './CompactFooter'
import { ProgressIndicator } from './ProgressIndicator'
import { AutoSaveIndicator } from './AutoSaveIndicator'
import { useOnboarding } from '../../contexts/OnboardingContext'

interface OnboardingLayoutProps {
  children: React.ReactNode
  currentStep: number
  totalSteps?: number
  stepLabels?: string[]
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
  currentStep,
  totalSteps = 3,
  stepLabels = []
}) => {
  const { isSaving } = useOnboarding()

  // Scroll to top when step changes (or on mount)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [currentStep])

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <WizardHeader />

      <div className="flex-1 flex flex-col">
        <div className="container-custom max-w-5xl mx-auto w-full">
          {/* Progress Indicator */}
          <div style={{ paddingTop: '40px', paddingBottom: '24px' }}>
            <ProgressIndicator
              currentStep={currentStep}
              totalSteps={totalSteps}
              stepLabels={stepLabels}
            />
          </div>

          {/* Section Divider */}
          <div className="border-b border-gray-200" style={{ marginBottom: '32px' }} />

          {/* Page Content */}
          <div className="w-full">
            {children}
          </div>
        </div>
      </div>

      <CompactFooter />

      {/* Auto-save Indicator */}
      <AutoSaveIndicator isSaving={isSaving} />
    </div>
  )
}
